// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import VueCookie from 'vue-cookie'

//导入ElementUI
import '@/element-ui'
import '@/element-ui-theme'
//导入图标库
import '@/icons'
//导入功能
import httpRequest from '@/utils/httpRequest'
import {isAuth} from '@/utils'
import cloneDeep from 'lodash/cloneDeep'
import dictSelect from '@/components/select/dict-select'
import bankSelect from '@/components/bank/bank-select'
import bankSelectEx from '@/components/bank/bank-select-ex'
import bankLevelSelect from '@/components/bank/bank-level-select'
import bankSelectByTypeLevel from '@/components/bank/bank-type-level-select'
import menuSelect from '@/components/menu/menu-select'
import userSelect from '@/components/user/user-select'
import roleSelect from '@/components/user/role-select'
import msgTypeSelect from '@/components/user/msg-type-select'
import noticeDrawer from '@/components/notice-drawer/notice-drawer'
import areaUse from '@/components/area/area-use'
import page from '@/components/page/index'
import pagination from '@/components/Pagination/index'
import dateTimePicker from '@/components/datetime-picker/index'
import datePicker from '@/components/date-picker/index'
import JlDatetimePicker from '@/components/datetime-picker/jl-datetime-picker';
import JlDatePicker from '@/components/date-picker/jl-date-picker';
import generalDatePicker from '@/components/date-picker/general-date-picker';
import DIYImage from '@/components/img/index'
import BackToTop from '@/components/backTop/index'
import Screenfull from '@/components/screenfull/index'
import ChangeTheme from '@/components/theme/index'
import elquarterPicker from '@/components/date-picker/elquarter-picker'
import monthPicker from '@/components/date-picker/month-picker'
import AppSelect from "@/components/app/app-select";
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
// 引入防止重复点击指令
import preventReClick from '@/utils/noDbClick'
// 导入阿里字体图标
import './assets/icon/iconfont.css'
// 打印
import Print from 'vue-print-nb'

//import '@/assets/scss/index.scss'
//import '@/assets/scss/global.scss'

Vue.use(preventReClick)

Vue.component("DIYImage", DIYImage)
Vue.component("bank-select", bankSelect);
Vue.component("dict-select", dictSelect);
Vue.component("bank-level-select", bankLevelSelect);
Vue.component("bank-select-ex", bankSelectEx);
Vue.component("bank-type-level-select", bankSelectByTypeLevel);
Vue.component("app-select", AppSelect);
Vue.component("menu-select", menuSelect);
Vue.component("user-select", userSelect);
Vue.component("role-select", roleSelect);
Vue.component("msg-type-select", msgTypeSelect);
Vue.component("notice-drawer", noticeDrawer);
Vue.component("area-use", areaUse);
Vue.component("page", page)
Vue.component("pagination", pagination)
Vue.component("BackToTop", BackToTop)
Vue.component("datetime-picker", dateTimePicker)
Vue.component("date-picker", datePicker)
Vue.component("jl-datetime-picker", JlDatetimePicker)
Vue.component("jl-date-picker", JlDatePicker)
Vue.component("general-date-picker", generalDatePicker)
Vue.component("elquarter-picker", elquarterPicker)
Vue.component("Screenfull", Screenfull)
Vue.component("ChangeTheme", ChangeTheme)
Vue.component("month-picker", monthPicker)

Vue.use(VueCookie)
Vue.config.productionTip = false

// 注册
Vue.use(Print)

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.$moment = moment // ajax请求方法
Vue.prototype.isAuth = isAuth     // 权限方法

// 过滤器 过滤时间
Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  return `${y}-${m}-${d}`
})
Vue.filter('dateTimeFormat', function (originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})
Vue.filter('cpuFilter', function (value) {
  if (value === undefined || value === null) return '0.00'
  const num = parseFloat(value)
  return isNaN(num) ? '0.00' : num.toFixed(2)
})
//int转中文数字
Vue.filter('intToChinese', function(value, str) {
  const numbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  const units = ['', '十', '百', '千', '万'];
  let result = '';

  if (!value) return numbers[0];

  while (value > 0) {
    const num = value % 10;
    const unit = Math.floor(value / 10);
    result = numbers[num] + units[unit] + result;
    value = Math.floor(value / 100);
  }
  if (str) {
    return result.replace(/^一十/, '十') + str
  } else {
    return result.replace(/^一十/, '十')
  }
});
/**
 * 页面显示字典转换
 */
Vue.prototype.formatValue = function (value, dictCode, defaultLabel) {
  let arrayList = store.state.dictionary.dict[dictCode];
  let isExist = false;
  if (arrayList != undefined) {
    if (arrayList.length > 0) {
      arrayList.forEach((item) => {
        value += ''
        if (item.value == value) {
          value = item.label;
          isExist = true
        }
      });
    }
  }
  if (defaultLabel != undefined && !isExist) {
    value = defaultLabel;
  }
  return value;
}
/**
 * 分转元 1001 ->10.01
 * @param price 分
 * @returns {string} 元
 */
Vue.prototype.fenToYuan = function (price) {
  if (typeof price === 'undefined') return '0.00'
  const parsedNumber = typeof price === 'string' ? parseFloat(price) : price
  return (parsedNumber / 100.0).toFixed(2)
}
/**
 * 元转分 10.01 -> 1001
 * @param amount 元
 * @returns {number} 分
 */
Vue.prototype.yuanToFen = function (amount){
  if (typeof amount === 'undefined') return 0
  const parsedNumber = typeof amount === 'string' ? parseFloat(amount) : amount
  return Math.round(parsedNumber * 100)
}
Vue.prototype.dataFromYuanToFen = function (data) {
  const convertKeys = ['price'] // 可扩展其他需要转换的字段关键词

  // 递归处理函数
  const deepConvert = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(item => deepConvert(item))
    } else if (obj && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        // 检测字段名包含关键词
        const needConvert = convertKeys.some(k => key.toLowerCase().includes(k))

        // 执行转换或继续递归
        acc[key] = needConvert ? this.yuanToFen(obj[key]) : deepConvert(obj[key])

        return acc
      }, {})
    }
  }

  return deepConvert(data)
},

/**
 * 日期格式转换字符串
 */
Vue.prototype.dateFormatValue = function (date) {
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let mm = date.getMinutes();
  mm = mm < 10 ? ('0' + mm) : mm;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + m + '-' + d;
},

  /**
   * 日期时间格式转换字符串
   */
  Vue.prototype.dateTimeFormatValue = function (date) {
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  },

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})
/*修改标题栏*/
document.getElementById("headTitle").innerHTML = window.SITE_CONFIG.title;

Vue.config.devtools = true



// WEBPACK FOOTER //
// ./src/main.js